import {
    getThemeProblems,
    getProblemsInCourse,
    //@ts-ignore
} from '@yandex-int/k-common/client/api';
//@ts-ignore
import { LessonProblem } from '@yandex-int/k-common/typings';
import { showNetworkError } from 'platform-components/src/components/notification/actions';
import { call, put, takeEvery, all, select } from 'redux-saga/effects';

import * as lessonSelectors from 'common.components/lesson/selectors';

import * as actions from './actions';
import * as constants from './constants';
import * as selectors from './selectors';
import { LessonInfo } from './typings';

export function* problemsSagasWatcher() {
    yield all([
        takeEvery(constants.GET_PROBLEMS_REQUEST, getProblemsSaga),
        takeEvery(constants.GET_PROBLEMS_IN_COURSE_REQUEST, getProblemsInCourseSaga),
    ]);
}

function* getProblemsSaga(action: ReturnType<typeof actions.getProblemsRequest>) {
    try {
        const { stackId } = action;
        let problems: Array<LessonProblem> = yield select(selectors.getProblemsByStackId, { stackId });

        if (!problems.length) {
            problems = yield call(getThemeProblems, { themeId: stackId });
            yield put(actions.getProblemsSuccess(problems, stackId));
        }

        const problemIds = problems.map(({ id }: { id: number }) => id);

        if (problemIds.length) {
            const courseId: number | null = yield select(lessonSelectors.getLessonOrCurrentYearCourseId);

            if (courseId) {
                yield put(actions.getProblemsInCourseRequest(problemIds, courseId));
            }
        }
    } catch (error) {
        console.error(error);

        yield put(showNetworkError(error));
        yield put(actions.getProblemsError(error));
    }
}

function* getProblemsInCourseSaga(action: ReturnType<typeof actions.getProblemsInCourseRequest>) {
    try {
        const { problemIds, courseId } = action;

        const problemsInCourse: Record<number, Array<LessonInfo>> = courseId
            ? yield call(getProblemsInCourse, courseId, problemIds)
            : [];
        yield put(actions.getProblemsInCourseSuccess(problemsInCourse, courseId));
    } catch (error) {
        console.error(error);

        yield put(showNetworkError(error));
    }
}
